import { useQuery } from '@apollo/client'
import { GET_FUTURE_WORK_COUNT_FOR_STAFF_PREPARATION_TASK } from '@/modules/API/staff/staffPreparationTask'

export function useFutureWorkCountForStaffPreparationTask(
    daycareId: number,
    staffPreparationTaskId: number,
    skip: boolean
): number {
    const { data } = useQuery(GET_FUTURE_WORK_COUNT_FOR_STAFF_PREPARATION_TASK, {
        skip,
        fetchPolicy: 'network-only',
        variables: { daycareId, staffPreparationTaskId }
    })

    return data?.getFutureWorkCountForStaffPreparationTask ?? 0
}
